<p>
  checkout works!
  {{appointment}}
  <button (click)="change_status()">change status</button>
</p>
